<template>

  <div>
    <div class="pt-lg-2 pb-2 pr-lg-5 pl-lg-5 col-lg-8 col-12 offset-lg-2">
      <iframe
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2431.528795946039
!2d9.986178616519194!3d52.45145007980131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f
13.1!3m3!1m2!1s0x47b00f6e0e1a044d%3A0x703901a72d66e12d!2sWernicke%20Fotograf
ie!5e0!3m2!1sde!2sde!4v1595430362064!5m2!1sde!2sde" width="100%" height="300"
frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
tabindex="0"></iframe>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-8 col-12 p-lg-5 p-2 ">
        <div class="row">
          <div class="col-md-2 col-xs-8 pt-3 text-left offset-lg-1 adress">
            <h6><icon :icon="['fas', 'address-book']" class=""></icon> Adresse:</h6>
            <p class="pl-3">Baltrumweg 11<br>
              31303 Burgdorf</p>
            <h6><icon :icon="['fas', 'phone']"></icon> Telefon und Mobil:</h6>
            <p class="pl-3">+49 5136 894563<br>
              +49 177 2049572</p>
            <h6><icon :icon="['fas', 'at']"></icon> Email:</h6>
            <p class="pl-3"><a href="mailto:info@wernicke-foto.de">info@wernicke-foto.de</a></p>
            <h6><icon :icon="['fas', 'hashtag']"></icon> Social Media:</h6>
            <p class="pl-3"><a href="https://www.instagram.com/frank.wernicke/"><icon :icon="['fab', 'instagram']"></icon></a></p>
          </div>
          <div class="col-lg-7 offset-lg-2 col-12">
            <form class="field" @submit.prevent="sendEmail">
              <div class="form-row">
                <div class="col-md-6 mb-2 ">
                  <!--              <label for="name_input">Name</label>-->
                  <input class="field-sm form-control" type="text" name="user_name" id="name_input" placeholder="Name" v-model="name">
                  <div class="invalid-feedback">Bitte geben Sie einen Namen ein.</div>
                </div>
                <div class="col-md-6 mb-2">
                  <!--              <label for="user_email">Email</label>-->
                  <input type="email" class="field-sm form-control" name="user_email" id="user_email" placeholder="Email" v-model="mail">
                  <div class="invalid-feedback">Bitte geben Sie eine Email-Adresse ein.</div>
                </div>
              </div>
              <input type="hidden" name="contact_number">

              <div class="form-group form-inline mt-3">
                <!--            <label for="user_message">Message</label>-->
                <textarea class="field-text form-control w-100" name="message" id="user_message" placeholder="Nachricht" v-model="text"></textarea>
                <div class="invalid-feedback"></div>
              </div>
              <div class="form-check text-left">
                <input type="checkbox" class="form-check-input" v-model="checked">
                <label class="form-check-label"><small>Mit der Markierung dieses Kästchens, geben Sie Ihr Einverständnis, dass wir Ihre Daten gemäß der EU-Richtlinie (DGSUV) verwenden dürfen</small></label>
              </div>

              <div class="row pl-3">
                <button :disabled="!checked" class="btn btn-dark" type="submit" value="Abschicken">Abschicken</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import emailjs from 'emailjs-com'
  export default {
    name: "Contact",
    data() {
      return {
        contact_number: 0,
        checked: false,
        name: '',
        mail: '',
        text: '',
        markers: []
      }
    },
    methods: {
      sendEmail: ((e) => {
        emailjs.sendForm('strato', 'anfrage_foto', e.target, 'user_tzks4sHYnrTLdaOia4bck')
            .then(() => {
              alert('Nachricht erfolgreich versendet')
              // this.clear();
            }, (error) => {
              console.log('FAILED...', error);
            });
      }),
      clear() {
        this.text = '';
        this.mail = '';
        this.name = '';
        this.checked = false;
      }
    },
    created() {
      this.contact_number = Math.random() * 100000 ;

    }
  }
</script>

<style scoped>
 .field {
   padding: 5px;
 }
 .adress {
   border: 1px solid #f8f9fa;
   background-color: #f8f9fa;
   border-radius: 5px;
 }
 .field-sm {
   /*min-width: 200px;*/
   /*max-width: 40%;*/
   /*padding-right: 20px;*/
 }
 .field-text {
   /*padding-top: 20px;*/
   /*padding-right: 20px;*/
   /*min-width: 60%;*/

 }
</style>